import api from './api';

// ✅ Definimos la base del CRM para que coincida con el backend
const CRM_BASE = '/crm';

// ════════════════════════════════════════════════════════════════════════════
// 📋 PROSPECTOS
// ════════════════════════════════════════════════════════════════════════════
export const getProspectos = (params = {}) => {
  return api.get(`${CRM_BASE}/prospectos`, { params });
};

export const getProspectoById = (id) => {
  return api.get(`${CRM_BASE}/prospectos/${id}`);
};

export const createProspecto = (data) => {
  return api.post(`${CRM_BASE}/prospectos`, data);
};

export const updateProspecto = (id, data) => {
  return api.put(`${CRM_BASE}/prospectos/${id}`, data);
};

export const deleteProspecto = (id) => {
  return api.delete(`${CRM_BASE}/prospectos/${id}`);
};

// ════════════════════════════════════════════════════════════════════════════
// 💼 OPORTUNIDADES
// ════════════════════════════════════════════════════════════════════════════
export const getOportunidades = (params = {}) => {
  return api.get(`${CRM_BASE}/oportunidades`, { params });
};

export const getMisOportunidades = () => {
  return api.get(`${CRM_BASE}/oportunidades/mias`);
};

export const getOportunidadById = (id) => {
  return api.get(`${CRM_BASE}/oportunidades/${id}`);
};

export const createOportunidad = (data) => {
  return api.post(`${CRM_BASE}/oportunidades`, data);
};

export const updateOportunidad = (id, data) => {
  return api.put(`${CRM_BASE}/oportunidades/${id}`, data);
};

export const moverEtapaOportunidad = (id, data) => {
  return api.put(`${CRM_BASE}/oportunidades/${id}/etapa`, data);
};

export const reasignarOportunidad = (id, data) => {
  return api.put(`${CRM_BASE}/oportunidades/${id}/reasignar`, data);
};

export const deleteOportunidad = (id) => {
  return api.delete(`${CRM_BASE}/oportunidades/${id}`);
};

// ════════════════════════════════════════════════════════════════════════════
// 🔄 WORKFLOW - TRANSICIONES DE ETAPA (NUEVO)
// ════════════════════════════════════════════════════════════════════════════

/**
 * Transicionar oportunidad a siguiente etapa
 * POST /api/crm/workflow/oportunidades/:id/transicionar
 */
export const transicionarEtapa = (id, data) => {
  return api.post(`${CRM_BASE}/workflow/oportunidades/${id}/transicionar`, data);
};

/**
 * Obtener configuración del workflow
 * GET /api/crm/workflow/config
 */
export const getWorkflowConfig = () => {
  return api.get(`${CRM_BASE}/workflow/config`);
};

/**
 * Obtener estadísticas del pipeline
 * GET /api/crm/workflow/estadisticas
 */
export const getEstadisticasPipeline = () => {
  return api.get(`${CRM_BASE}/workflow/estadisticas`);
};

/**
 * Crear proyecto desde oportunidad (obra civil)
 * POST /api/crm/workflow/oportunidades/:id/crear-proyecto
 */
export const crearProyectoDesdeOportunidad = (id, data) => {
  return api.post(`${CRM_BASE}/workflow/oportunidades/${id}/crear-proyecto`, data);
};

/**
 * Crear factura desde oportunidad (servicios)
 * POST /api/crm/workflow/oportunidades/:id/crear-factura
 */
export const crearFacturaDesdeOportunidad = (id, data) => {
  return api.post(`${CRM_BASE}/workflow/oportunidades/${id}/crear-factura`, data);
};

// ════════════════════════════════════════════════════════════════════════════
// 📦 PARTIDAS ESTÁNDAR (CATÁLOGO) - NUEVO
// ════════════════════════════════════════════════════════════════════════════

/**
 * Cargar partidas estándar del catálogo
 * GET /api/crm/partidas
 */
export const cargarPartidasEstandar = (params = {}) => {
  return api.get(`${CRM_BASE}/partidas`, { params });
};

/**
 * Cargar categorías de partidas
 * GET /api/crm/partidas/categorias
 */
export const cargarCategoriasPartida = () => {
  return api.get(`${CRM_BASE}/partidas/categorias`);
};

/**
 * Crear partida estándar (admin)
 * POST /api/crm/partidas
 */
export const crearPartidaEstandar = (data) => {
  return api.post(`${CRM_BASE}/partidas`, data);
};

// ════════════════════════════════════════════════════════════════════════════
// 📝 SEGUIMIENTOS
// ════════════════════════════════════════════════════════════════════════════
export const getSeguimientos = (oportunidadId) => {
  return api.get(`${CRM_BASE}/seguimientos/${oportunidadId}`);
};

export const createSeguimiento = (data) => {
  return api.post(`${CRM_BASE}/seguimientos`, data);
};

export const completarSeguimiento = (id) => {
  return api.put(`${CRM_BASE}/seguimientos/${id}/completar`);
};

// ════════════════════════════════════════════════════════════════════════════
// 📄 COTIZACIONES RÁPIDAS
// ════════════════════════════════════════════════════════════════════════════

export const crearCotizacionRapida = (data) => {
  return api.post('/cotizaciones', data);
};

export const getCotizaciones = (params = {}) => {
  return api.get('/cotizaciones', { params });
};

export const getCotizacionById = (id) => {
  return api.get(`/cotizaciones/${id}`);
};

// ════════════════════════════════════════════════════════════════════════════
// 📊 DASHBOARD
// ════════════════════════════════════════════════════════════════════════════
export const getDashboardPipeline = () => {
  return api.get(`${CRM_BASE}/dashboard`);
};

// ════════════════════════════════════════════════════════════════════════════
// 🏭 INVENTARIO / MATERIALES (NUEVO - para servicios)
// ════════════════════════════════════════════════════════════════════════════

/**
 * Cargar materiales del inventario
 * GET /api/inventario/materiales
 */
export const cargarMaterialesInventario = (params = {}) => {
  return api.get('/materiales', { 
    params: { 
      activos: true, 
      con_stock: true,
      ...params 
    } 
  });
};
/**
 * Verificar stock de materiales
 * POST /api/inventario/verificar-stock
 */
export const verificarStockMateriales = (materiales) => {
  return api.post('/inventario/verificar-stock', { materiales });
};

/**
 * Reservar materiales para cotización
 * POST /api/inventario/reservar
 */
export const reservarMateriales = (data) => {
  return api.post('/inventario/reservar', data);
};

const crmService = {
  // Prospectos
  getProspectos,
  getProspectoById,
  createProspecto,
  updateProspecto,
  deleteProspecto,
  
  // Oportunidades
  getOportunidades,
  getMisOportunidades,
  getOportunidadById,
  createOportunidad,
  updateOportunidad,
  moverEtapaOportunidad,
  reasignarOportunidad,
  deleteOportunidad,
  
  // Workflow (nuevo)
  transicionarEtapa,
  getWorkflowConfig,
  getEstadisticasPipeline,
  crearProyectoDesdeOportunidad,
  crearFacturaDesdeOportunidad,
  
  // Partidas estándar (nuevo)
  cargarPartidasEstandar,
  cargarCategoriasPartida,
  crearPartidaEstandar,
  
  // Seguimientos
  getSeguimientos,
  createSeguimiento,
  completarSeguimiento,
  
  // Dashboard
  getDashboardPipeline,
  
  // Cotizaciones
  crearCotizacionRapida,
  getCotizaciones,
  getCotizacionById,
  
  // Inventario (nuevo)
  cargarMaterialesInventario,
  verificarStockMateriales,
  reservarMateriales
};

export default crmService;